import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=5f56c376&scoped=true"
import script from "./BigScreen.vue?vue&type=script&lang=js"
export * from "./BigScreen.vue?vue&type=script&lang=js"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=5f56c376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56c376",
  null
  
)

export default component.exports